import styled from "styled-components";

const distanceFromSides = `3`;

export const FreeSelectionBottomButton = styled.div`
    position: fixed;
    width: ${100 - (2 * distanceFromSides)}%;
    height: 50px;
    bottom: 10px;
    left: ${distanceFromSides}%;
    right: ${distanceFromSides}%;
    padding: 0;
    text-align: center;
    line-height: 30px;
    z-index: 1;
`;

export const FreeSelectionBottomButtonLabel = styled.label`
    font-size: 19px;
    font-weight: 400;
    line-height: 46px;
    text-align: center;
    color: #ffffff;
`;


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/FreeSelectionBottom/FreeSelectionBottomStyle.js